import React, { useEffect, useState } from "react";
import "./HistoriqueEspace.css";
import MenuEspace from "./MenuSpace";
import HistoriqueVisiteur from "../../../../Services/Visiteure/HistoriqueVisiteur";
import { CommandeVisiteur } from "../../../../Modeles/Commande";
import DetailCommandeService from "../../../../Services/Admin/DetailCommandeService";
import { useParams } from "react-router-dom";
import axios from "axios";
import CreateReclamationPopup from "../../../../components/CreateReclamationPopup";
import { formatCodeCommande } from "../../../../Services/CodeTrackingHelper";
import PayArticleModal from "../../../Common/PayArticleModal";

export interface commandeType {
  product: CommandeVisiteur[];
  messageErros: string;
}

type DetailCommande = {
  id?: any;
  idCommande?: number;
  RefArticle: string;
  NomArticle: string;
  quantity: number;
  prix: number;
  Statut: string;
  vendeur?: string;
};

const getStatusClass = (statut: string): string => {
  const s = (statut || "").toLowerCase();
  if (s.includes("confirm") || s.includes("pay") || s.includes("valid")) return "status-confirme-hvu";
  if (s.includes("annul")) return "status-annule-hvu";
  if (s.includes("en cours") || s.includes("en coure")) return "status-en-cours-hvu";
  return "status-default-hvu";
};

export const HistoriqueEspace: React.FC = () => {
  const [state, setState] = useState<commandeType>({
    product: [] as CommandeVisiteur[],
    messageErros: "Aucune commande",
  });

  const [loading, setLoading] = useState<boolean>(true);
  const [Loadingdetail, setLoadingdetail] = useState<boolean>(true);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [details, setDetails] = useState<DetailCommande[]>([]);
  const [reclamationPopup, setReclamationPopup] = useState<boolean>(false);
  const [reclamationRef, setReclamationRef] = useState<string>("");
  const [selectedCommande, setSelectedCommande] = useState<number | null>(null);
  const [selectedCommandeCode, setSelectedCommandeCode] = useState<string>("");
  // Set of refs already claimed: "CMD-12", "CMD-45", …
  const [claimedRefs, setClaimedRefs] = useState<Set<string>>(new Set());
  const [itemToPay, setItemToPay] = useState<any | null>(null);
  const [paySuccessMsg, setPaySuccessMsg] = useState<string>("");

  const { id } = useParams();

  useEffect(() => {
    const visiteurId = localStorage.getItem("VisiteurId");
    setLoading(true);

    // Load commandes + existing reclamations in parallel
    Promise.all([
      HistoriqueVisiteur().getHistoriqueVisiteur(),
      visiteurId
        ? axios.get(`${process.env.REACT_APP_PHP_APP_URL}/visiteur/${visiteurId}/reclamations`)
        : Promise.resolve({ data: [] }),
    ])
      .then(([cmdRes, recRes]) => {
        setState({ ...state, product: cmdRes.data });
        // Build a set of already-claimed refs
        const refs = new Set<string>(
          (recRes.data as any[]).map((r: any) => r.RefCommande as string)
        );
        setClaimedRefs(refs);
        setLoading(false);
      })
      .catch((err) => {
        setState({ ...state, messageErros: err.message });
        setLoading(false);
      });
  }, []);

  // Called by popup after successful submission — mark ref as claimed immediately
  const handleReclamationSuccess = (ref: string) => {
    setClaimedRefs((prev) => new Set(prev).add(ref));
  };

  const handleVoir = async (order: CommandeVisiteur) => {
    try {
      const commandeId = order.IdCommande;
      setSelectedCommande(commandeId ?? null);
      setSelectedCommandeCode(formatCodeCommande(order.RefCommande, order.IdCommande, order.DateCommande));
      setLoadingdetail(true);
      setShowModal(true);
      const res = await DetailCommandeService(commandeId).getCommande();
      setDetails(res.data);
    } catch (error) {
      setDetails([]);
    } finally {
      setLoadingdetail(false);
    }
  };

  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const GoBack = () => window.history.back();

  /* ─── MOBILE VIEW ─────────────────────────────── */
  if (screenWidth <= 450) {
    return (
      <>
        <div className="mobile-page-header-hvu">
          <h3>Historique des commandes</h3>
          <h6>Consultez l'historique complet de vos commandes et leur statut.</h6>
        </div>

        <div className="mobile-card-container-hvu">
          {state.product.length > 0 ? (
            state.product.map((item, index) => (
              <div key={index} className="mobile-card-hvu">
                {/* Card header */}
                <div className="mobile-card-header-hvu">
                  <span className="mobile-card-id-hvu">{formatCodeCommande(item.RefCommande, item.IdCommande, item.DateCommande)}</span>
                  <span
                    className={`mobile-card-status-hvu ${getStatusClass(item.Statut)}`}
                  >
                    {item.Statut}
                  </span>
                </div>

                {/* Card content */}
                <div className="mobile-card-content-hvu">
                  <div className="mobile-card-row-hvu">
                    <span className="mobile-card-label-hvu">Magasin</span>
                    <span className="mobile-card-value-hvu">{item.NomMagasin}</span>
                  </div>
                  <div className="mobile-card-row-hvu">
                    <span className="mobile-card-label-hvu">Total</span>
                    <span className="mobile-card-value-hvu">{item.TotalCommandeHT} MAD</span>
                  </div>
                  <div className="mobile-card-row-hvu">
                    <span className="mobile-card-label-hvu">Date</span>
                    <span className="mobile-card-value-hvu">{item.DateCommande}</span>
                  </div>
                  <div className="mobile-card-row-hvu" style={{ display: "flex", gap: 10, marginTop: 10 }}>
                    <button
                      className="btn-voir-hvu"
                      style={{ flex: 1, padding: "8px" }}
                      onClick={() => handleVoir(item)}
                    >
                      <i className="bi bi-eye-fill" /> Voir
                    </button>
                    {claimedRefs.has(`CMD-${item.IdCommande}`) ? (
                      <span
                        style={{
                          flex: 1,
                          background: "rgba(107,114,128,0.12)",
                          color: "#6b7280",
                          border: "1.5px solid rgba(107,114,128,0.25)",
                          borderRadius: 8,
                          padding: "8px",
                          fontSize: "0.78rem",
                          fontWeight: 700,
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 5,
                        }}
                      >
                        <i className="bi bi-shield-check" /> Réclamé
                      </span>
                    ) : (
                      <button
                        style={{
                          flex: 1,
                          background: "linear-gradient(135deg,#ef4444,#dc2626)",
                          color: "#fff",
                          border: "none",
                          borderRadius: 8,
                          padding: "8px",
                          fontSize: "0.8rem",
                          fontWeight: 700,
                          cursor: "pointer",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 5,
                        }}
                        onClick={() => {
                          setReclamationRef(`CMD-${item.IdCommande}`);
                          setReclamationPopup(true);
                        }}
                      >
                        <i className="bi bi-shield-exclamation" /> Réclamer
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="mobile-empty-hvu">
              <i className="bi bi-inbox" />
              <p>{state.messageErros}</p>
            </div>
          )}
        </div>
      </>
    );
  }

  /* ─── DESKTOP VIEW ────────────────────────────── */
  return (
    <div className="dashboard-escpaceVisiteur-hvu">
      <main className="main-content-escpaceVisiteur-hvu">

        {/* Back */}
        <button onClick={GoBack} className="back-button-visiteurinter-hvu">
          <i className="bi bi-arrow-left-circle" /> Retour
        </button>

        <h3>Historique des commandes</h3>
        <h6 className="mb-5 mt-2">
          Consultez l'historique complet de vos commandes et leur statut.
        </h6>

        {/* Loading */}
        {loading ? (
          <div className="loader-wrapper-hvu">
            <div className="custom-spinner-hvu" role="status" />
            <span className="loader-charg-hvu">Chargement</span>
          </div>
        ) : state.product.length === 0 ? (
          <div className="empty-state-hvu">
            <i className="bi bi-inbox" />
            <p>{state.messageErros}</p>
          </div>
        ) : (
          <table className="orders-table-hvu">
            <thead>
              <tr>
                <th>Commande</th>
                <th>Magasin</th>
                <th>Montant</th>
                <th>Date</th>
                <th>Statut</th>
                <th>Voir</th>
              </tr>
            </thead>
            <tbody>
              {state.product.map((order, i) => (
                <tr key={i}>
                  <td><strong style={{ fontFamily: "monospace" }}>{formatCodeCommande(order.RefCommande, order.IdCommande, order.DateCommande)}</strong></td>
                  <td>{order.NomClient}</td>
                  <td><strong>{order.TotalCommandeHT} MAD</strong></td>
                  <td>
                    <div className="date-cell-hvu">
                      <i className="bi bi-calendar3" />
                      {order.DateCommande}
                    </div>
                  </td>
                  <td>
                    <span className={`status-badge-hvu ${getStatusClass(order.Statut)}`}>
                      {order.Statut}
                    </span>
                  </td>
                  <td>
                    <div style={{ display: "flex", gap: 8 }}>
                      <button
                        className="btn-voir-hvu"
                        onClick={() => handleVoir(order)}
                      >
                        <i className="bi bi-eye-fill" /> Voir
                      </button>
                      {claimedRefs.has(`CMD-${order.IdCommande}`) ? (
                        <span
                          style={{
                            background: "rgba(107,114,128,0.1)",
                            color: "#6b7280",
                            border: "1.5px solid rgba(107,114,128,0.2)",
                            borderRadius: 8,
                            padding: "5px 12px",
                            fontSize: "0.78rem",
                            fontWeight: 700,
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 5,
                          }}
                        >
                          <i className="bi bi-shield-check" /> Réclamé
                        </span>
                      ) : (
                        <button
                          style={{
                            background: "linear-gradient(135deg,#ef4444,#dc2626)",
                            color: "#fff",
                            border: "none",
                            borderRadius: 8,
                            padding: "5px 12px",
                            fontSize: "0.78rem",
                            fontWeight: 700,
                            cursor: "pointer",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 5,
                          }}
                          onClick={() => {
                            setReclamationRef(`CMD-${order.IdCommande}`);
                            setReclamationPopup(true);
                          }}
                        >
                          <i className="bi bi-shield-exclamation" /> Réclamer
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {/* ── MODAL ── */}
        {showModal && (
          <div className="modal-overlay-hvu">
            <div className="modal-box-hvu">

              <div className="modal-header-hvu">
                <h2>
                  Détails — <span style={{ fontFamily: "monospace" }}>{selectedCommandeCode || `#${selectedCommande}`}</span>
                </h2>
                <button className="modal-close-hvu" onClick={() => setShowModal(false)}>
                  <i className="bi bi-x-lg" />
                </button>
              </div>

              {details.length === 0 && !Loadingdetail ? (
                <div className="empty-state-hvu" style={{ minHeight: 140 }}>
                  <p>Aucun détail disponible</p>
                </div>
              ) : (
                <table className="modal-table-hvu">
                  <thead>
                    <tr>
                      <th>Réf Article</th>
                      <th>Nom Article</th>
                      <th>Vendeur</th>
                      <th>Quantité</th>
                      <th>Prix</th>
                      <th>Statut</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Loadingdetail ? (
                      <tr>
                        <td colSpan={7} className="modal-loading-hvu">
                          <div className="loader-wrapper-hvu" style={{ height: 80 }}>
                            <div className="custom-spinner-hvu" />
                            <span className="loader-charg-hvu">Chargement</span>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      details.map((d, i) => (
                        <tr key={i}>
                          <td>{d.RefArticle}</td>
                          <td>{d.NomArticle}</td>
                          <td>{d.vendeur || "—"}</td>
                          <td>{d.quantity}</td>
                          <td><strong>{d.prix} MAD</strong></td>
                          <td>
                            <span className={`status-badge-hvu ${getStatusClass(d.Statut)}`}>
                              {d.Statut}
                            </span>
                          </td>
                          <td>
                            {(() => {
                              const s = (d.Statut || "").toLowerCase();
                              if (s.includes("pay") || s.includes("confirm")) {
                                return <span style={{ color: "#10b981", fontWeight: 700, fontSize: "12px" }}>✓ Payé</span>;
                              }
                              if (s.includes("annul")) {
                                return <span style={{ color: "#9ca3af" }}>—</span>;
                              }
                              return (
                                <button
                                  style={{
                                    backgroundColor: "#2563eb",
                                    color: "#fff",
                                    border: "none",
                                    padding: "4px 10px",
                                    borderRadius: "6px",
                                    fontSize: "12px",
                                    fontWeight: 700,
                                    cursor: "pointer"
                                  }}
                                  onClick={() => setItemToPay(d)}
                                >
                                  💳 Payer
                                </button>
                              );
                            })()}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              )}

              <button
                className="btn-close-modal-hvu"
                onClick={() => setShowModal(false)}
              >
                <i className="bi bi-x-lg" /> Fermer
              </button>
            </div>
          </div>
        )}
      </main>
      <CreateReclamationPopup
        isOpen={reclamationPopup}
        onClose={() => setReclamationPopup(false)}
        refId={reclamationRef}
        type="commande"
        onSuccess={handleReclamationSuccess}
      />
      {paySuccessMsg && (
        <div style={{
          position: "fixed", bottom: "24px", right: "24px", zIndex: 9999,
          backgroundColor: "#10b981", color: "#fff", padding: "12px 20px",
          borderRadius: "10px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          fontWeight: 600, fontSize: "14px"
        }}>
          ✓ {paySuccessMsg}
        </div>
      )}
      <PayArticleModal
        isOpen={!!itemToPay}
        onClose={() => setItemToPay(null)}
        item={itemToPay}
        buyerType="visiteur"
        buyerId={localStorage.getItem("VisiteurId") || id}
        buyerName={localStorage.getItem("VisiteurNom") || localStorage.getItem("NomVisiteur") || localStorage.getItem("nom") || "Visiteur"}
        onSuccess={(newStatut) => {
          if (itemToPay) {
            setDetails((prev) =>
              prev.map((d) =>
                d.id === itemToPay.id || d.RefArticle === itemToPay.RefArticle ? { ...d, Statut: newStatut } : d
              )
            );
          }
          setPaySuccessMsg(`Article "${itemToPay?.NomArticle}" payé avec succès.`);
          setTimeout(() => setPaySuccessMsg(""), 4000);
        }}
      />
    </div>
  );
};